import { Component } from 'react';
import { safeCreateElement, safeUpdateContent, validateAndSanitizeInput } from '../../utils/SafeDOMUtil';


class BTSnackbar extends Component {

     componentDidMount = () => {
          let status = this.props.status ? this.props.status : "success";
          let time = this.props.time ? this.props.time : 3000;
          let snackbarWrapper = document.getElementById("bt-snackbar");
          if (snackbarWrapper) {
               snackbarWrapper.classList.add("bt-snackbar", status);
          }
          let btSnackbarWrapper = document.getElementById("bt-snackbar-wrapper");
          if (btSnackbarWrapper) {
               btSnackbarWrapper.classList.add("snackActive");
          }
          
          // Use safe DOM manipulation instead of innerHTML
          if (snackbarWrapper) {
               const msg = this.props.msg ? this.props.msg : 'Saved Successfully';
               
               // Validate and sanitize input
               const validation = validateAndSanitizeInput(msg, 500);
               const safeMsg = validation.isValid ? validation.sanitized : 'Saved Successfully';
               
               if (!validation.isValid) {
                    console.warn('BTSnackbar: Invalid message content', validation.error);
               }
               
               // Clear existing content safely
               while (snackbarWrapper.firstChild) {
                    snackbarWrapper.removeChild(snackbarWrapper.firstChild);
               }
               
               // Create elements safely
               const container = safeCreateElement('div', { className: 'icon-with-text' });
               const iconSpan = safeCreateElement('span', { className: 'bt-icon' });
               const textNode = document.createTextNode(safeMsg);
               
               container.appendChild(iconSpan);
               container.appendChild(textNode);
               snackbarWrapper.appendChild(container);
          }
          setTimeout(() => {
               const wrapper = document.getElementById("bt-snackbar-wrapper");
               if (wrapper) {
                    wrapper.classList.remove('snackActive');
               }
               if (snackbarWrapper) {
                    snackbarWrapper.classList.remove(status);
               }
               if (!!this.props.onHide) {
                    this.props.onHide();
               }
          }, time);
     }
     render = () => {
          return (null);
     }
}

export default BTSnackbar;
const status = { DANGER: 'danger', SUCCESS: 'success' };
const SnackStatus = status;
export { status, SnackStatus };

// Usage:
// <BTSnackbar msg="Alert" status="danger" />
// <BTSnackbar msg="Success" status="success" />
// <BTSnackbar msg="Invites sent" status="success" time="5000" onHide={...}/>
// <BTSnackbar msg={snackMessage} status={snackStatus} time="3000" onHide={...}/>